// extracted by mini-css-extract-plugin
module.exports = {"code":"CodeTemplate_code__2Brl6"};